export default __webpack_public_path__ + "static/media/taintedweapons.1a73bfd2.png";